export default "__VITE_ASSET__C1l1gO1N__"